<template>
  <div class="row upload-area mx-3 my-2" @dragleave.prevent @dragover.prevent @drop.prevent="onDrop">
    <div class="col">
      <img src="@/assets/images/cloud_up.png"/>
      <p v-html="textHtml" style="font-size:14px;"/>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props:["textHtml", "extension"],
  methods: {
    onDrop(event){
      // ファイル数チェックと拡張子チェックのみコンポーネントで行う
      // 以降の処理や固有のチェックは親側で行うこと
      if(event.dataTransfer.files.length > 1){
        this.$emit('drop-error', `複数ファイルはアップロードできません。`);
        return;
      }

      var splitArray = event.dataTransfer.files[0].name.split('.');
      if(splitArray[splitArray.length - 1].toLowerCase() != this.extension) {
        this.$emit('drop-error', `ファイル拡張子が異なります。ドラッグ可能な拡張子は${this.extension}です。`);
        return;
      }

      // ファイルを親にemit
      this.$emit('drop-success', event.dataTransfer.files[0]);
    }
  }
})
</script>
